import { render } from "./QuestionCategory.vue?vue&type=template&id=645c5774&scoped=true&ts=true"
import script from "./QuestionCategory.vue?vue&type=script&lang=ts"
export * from "./QuestionCategory.vue?vue&type=script&lang=ts"

import "./QuestionCategory.vue?vue&type=style&index=0&id=645c5774&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645c5774"]])

export default __exports__